module.exports = __webpack_public_path__ + "img/students-x.bb105945.svg";